export enum RollCompetitionStatus {
  Created = 'created',
  Open = 'open',
  Closed = 'closed',
}
